<template>
  <div class="load-bag" v-if="showLoader">
  <div class="lds-ripple" ><div></div><div></div></div>
  </div>
    <Dashboard/>
    <div class="content-wrapper">
    <div class="container-fluid">
      <div class="row">

      <!-- Icon Cards-->
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4">
            <div class="inforide">
              <div class="row">
                <router-link class="link" to="/users">
                <div class="col-lg-3 col-md-4 col-sm-4 col-4 rideone">
                    <img src="images/logo.jpg">
                </div>
                <div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty">
                    <h4>Total Verified  Users</h4>
                    <h2>{{this.resultUser}}</h2>
                </div>
              </router-link>
              </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4">
            <div class="inforide">
              <div class="row">
                <router-link class="link" to="/requested_users">
                <div class="col-lg-3 col-md-4 col-sm-4 col-4 ridetwo">
                    <img src="images/logo.jpg">
                </div>
                <div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty">
                    <h4>Total Requested  Users</h4>
                    <h2>{{this.resultRequestUser}}</h2>
                </div>
              </router-link>
              </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4">
            <div class="inforide">
              <div class="row">
                <router-link class="link" to="/parking">
                <div class="col-lg-3 col-md-4 col-sm-4 col-4 ridetwo">
                    <img src="images/logo.jpg">
                </div>
                <div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty">
                    <h4>Total Parking Spots</h4>
                    <h2>{{this.resultParking}}</h2>
                </div>
              </router-link>
              </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4">
            <div class="inforide">
              <div class="row">
                <router-link class="link" to="/request">
                <div class="col-lg-3 col-md-4 col-sm-4 col-4 rideone">
                    <img src="images/logo.jpg">
                </div>
                <div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty">
                    <h4>Total Parking Requests</h4>
                    <h2>{{this.resultRequest}}</h2>
                </div>
              </router-link>
              </div>
            </div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Dashboard from '@/components/Dashboard.vue'
import axios from "../services/customAxios";
import { base_url } from "../config";
export default {
  components: {
    Dashboard
  },
  data(){
    return{
      resultUser:"",  
      resultRequest:"",
      resultParking:"",     
      resultRequestUser:"",     
      base_url: base_url,
      showLoader: true,
    }
  },
  methods:{
    async LoadUser() {
      let response = await axios.get(`${base_url}/get_all_verified_user`); 
      // console.log("======>>>>>",response.data.result.length);
      this.resultUser = response.data.result.length;
      this.showLoader = false;
    },
    async LoadRequestUser() {
      let response = await axios.get(`${base_url}/get_all_requested_user`); 
      // console.log("======>>>>>",response.data.result.length);
      this.resultRequestUser = response.data.result.length;
      this.showLoader = false;
    },
    async LoadParking() {
      let response = await axios.get(`${base_url}/get_all_parking`); 
      // console.log("==========>>>>>",response.data.data);
      this.resultParking = response.data.result.length;
      this.showLoader = false;
    },
    async LoadRequest() {
      let response = await axios.get(`${base_url}/get_all_parking_request`); 
      // console.log("======>>>>>",response.data.result.length);
      this.resultRequest = response.data.result.length;
      this.showLoader = false;
    },
  },
  async mounted(){
    this.LoadUser();
    this.LoadParking();
    this.LoadRequest();
    this.LoadRequestUser();
  }
}
</script>

<style>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  width: 300px;
  height: 300px;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 100px;
    left: 100px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 100px;
    left: 100px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 100px;
    left: 100px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 200px;
    height: 200px;
    opacity: 0;
  }
}
.load-bag {
  position: fixed;
  top: 0;
  background:#0000006b;
  z-index: 999;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  display: flex;
}

</style>
<style scoped>
a.link{
  display: flex;
  text-decoration: none;
}
</style>